module.exports = __webpack_public_path__ + "static/media/headerv3.579a8750.png";